import { Alert } from '../../../components/Alert'

export function ConfidentialWarning() {
  return (
    <Alert className="mt-2 justify-center" variant="warning" size="small" icon={null}>
      <strong>Confidential Treatment Requested.</strong> (The Manager has omitted from this public Form 13F one or more
      holding(s) for which it is requesting confidential treatment from the U.S. Securities and Exchange Commission
      pursuant to section 13(f) of the Exchange Act and rule 24b-2 thereunder)
    </Alert>
  )
}
